export const DEFAULT_SEPARATOR = " ";
export const CASE_TYPE_CODE = "Demande";
export const DEFAULT_VALUE = "-";
